module.exports = __webpack_public_path__ + "static/media/certified-pl.fcfecfc7.png";